<template>
	<iframe :style="element.styles" :src="element.attributes.src" :width="element.attributes.width"
		:height="element.attributes.height"></iframe>
</template>

<script lang="ts">
import { Container } from "@/types/customPage";
import { defineComponent, PropType } from "vue";
import { doActionHelper } from "@/utils/action";

export default defineComponent({
	props: {
		element: {
			type: Object as PropType<Container>,
			required: true,
		},
	},
	methods: {
		doAction(container: Container) {
			doActionHelper(container);
		},
	},
});
</script>

<style scoped lang="scss"></style>
